import { render } from "./Register.vue?vue&type=template&id=48e467d3&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=48e467d3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48e467d3"

export default script